var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3332 4.00001C17.3332 3.26363 16.7362 2.66667 15.9998 2.66667C15.2635 2.66667 14.6665 3.26363 14.6665 4.00001V14.6667H3.99984C3.26346 14.6667 2.6665 15.2636 2.6665 16C2.6665 16.7364 3.26346 17.3333 3.99984 17.3333H14.6665V28C14.6665 28.7364 15.2635 29.3333 15.9998 29.3333C16.7362 29.3333 17.3332 28.7364 17.3332 28V17.3333H27.9998C28.7362 17.3333 29.3332 16.7364 29.3332 16C29.3332 15.2636 28.7362 14.6667 27.9998 14.6667H17.3332V4.00001Z",
    fill: "#979092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.63e9296877075657a72bd499dc7ba98f.svg";
export { ForwardRef as ReactComponent };